<template>
    <div class="pop-page">
        <div class="pop-box" v-if="showUserLowerLevel == 1">
            <img class="close-img" @click="back" src="../../assets/imgs/closed.png" alt="Close">
            <div v-if="status !== 'registered'">
                <div class="pop-text">{{$t('home.register')}}</div>
                <div class="register-text">{{$t('home.referrerAddress')}}</div>
                <input class="register-input" type="text" v-model="address" :placeholder="$t('home.pleaseEnter')">
                <div class="warring-text" v-if="showWarring">
                    <div>{{$t('home.pleaseRevise')}}</div>
                </div>
                <div class="connect-wallet-btn" v-if="!userAddress" @click="requestAccounts">{{$t('home.connectWallet')}}</div>
                <div class="neterror-btn" v-if="userAddress && chain != 56" @click="changeEthereumChain('56')">
                    <img src="../../assets/imgs/err_close.png" alt="Error">
                    <div>{{$t('home.neterror')}}</div>
                </div>
                <div class="confirm-disabled-btn" v-if="userAddress && chain == 56 && !address && !status">{{$t('home.confirm')}}</div>
                <div class="confirm-btn" v-if="userAddress && chain == 56 && address && !status" @click="confirm">{{$t('home.confirm')}}</div>
                <div class="confirm-success-btn" v-if="userAddress && chain == 56 && address && status === 'success'">{{$t('home.registrationSucceeded')}}</div>
                <div class="loading-btn" v-if="userAddress && chain == 56 && address && status === 'loading'">
                    <loading />
                </div>
            </div>
            <div v-else>
                <div class="pop-text">{{$t('home.registered')}}</div>
                <div class="register-text">{{$t('home.myReferrals')}}</div>
                <div class="referrals-text">{{userInviter}}</div>
                <div class="confirm-btn" @click="showUserLowerLevel = 2">{{$t('home.viewSubordinates')}}</div>
            </div>
        </div>
        <div class="pop-box" style="top:calc(50vh - 340px);" v-if="showUserLowerLevel == 2">
            <img class="close-img" @click="back" src="../../assets/imgs/closed.png" alt="Close">
            <div class="pop-text">{{$t('home.viewSubordinates')}}</div>
            <div class="register-text">{{$t('home.myAddress')}}</div>
            <div class="referrals-text">{{userAddress}}</div>
            <div class="number-subordinates-text">{{$t('home.numberOfSubordinates')}}:{{userLowerLevel.length}}</div>
            <div class="lower-level-box" v-for="(item,index) in showUserLowerLevelList" :key="index">
                <img src="../../assets/imgs/user.png" alt="User">
                <div>{{item}}</div>
            </div>
            <div class="pagenation" v-if="this.userLowerLevel.length>5">
                <img class="left" :class="{'opacity-6':currentPage==1}" @click="leftPage" src="../../assets/imgs/left.png" alt="Left">
                <div class="page">
                    <span class="current-page">{{currentPage}}</span>
                    <span class="total-page">/{{totalPage}}</span>
                </div>
                <img class="next" :class="{'opacity-6':currentPage==totalPage}" @click="nextPage" src="../../assets/imgs/next.png" alt="Left">
            </div>
        </div>
    </div>
</template>

<script>
    import Web3 from 'web3'
    import loading from '../../components/loading.vue'
    import registerAbi from '../../abi/register.json'
  export default {
    data() {
      return {
          address: '',
          userAddress: '',
          showWarring: false,
          chain: '',
          status: '',
          networkBsc: {
                alias: 'bsc',
                name: 'BSC',
                chainName: 'BSC',
                icon: 'img-bsc',
                decimals: 18,
                nativeName: 'Binance Chain Native Token',
                symbol: 'tBNB',
                blockNumberSpeed: 3000,
                chainId: 56,
                rpcUrl: 'https://bsc-dataseed.binance.org',
                blockUrl: 'https://bscscan.com/',
            },
            contractAddress: '0x7d1164564F9B34483E17E76f1a662795839f589A',
            userInviter: '',
            userLowerLevel: [],
            showUserLowerLevel: -1,
            currentPage: 1,
      };
    },
    components: { loading },
    computed: {
        totalPage () {
            console.log(Math.floor(this.userLowerLevel.length/5))
            return Math.ceil(this.userLowerLevel.length/5)
        },
        showUserLowerLevelList(){
            return this.userLowerLevel.slice((this.currentPage-1)*5,this.currentPage*5)
        }
    },
    mounted(){
        if (typeof web3 !== 'undefined') {
            window.web3 = new Web3(window.web3.currentProvider)
        } else {
            window.web3 = new Web3(Web3.givenProvider)
            // window.web3 = new Web3(new Web3.providers.HttpProvider(config.network.eth.rpcUrl))
        }
        window.ethereum.on('chainChanged', _ => {
            this.getWindowNetwork()
        })
        window.ethereum.on('accountsChanged', _ => {
            this.requestAccounts()
        })
        this.requestAccounts()
        this.getWindowNetwork()
    },
    watch: {
        chain (val) {
            if (val == 56 && this.userAddress) {
                this.isRegister()
                this.userInfo()
            }else{
                this.showUserLowerLevel = 1
            }
        },
        userAddress (val) {
            if (this.chain == 56 && val) {
                this.isRegister()
                this.userInfo()
            }else{
                this.showUserLowerLevel = 1
            }
        },
    },
    methods:{
        async confirm () {
            const contract = new window.web3.eth.Contract( registerAbi, this.contractAddress, { from: this.userAddress })
            if(!window.web3.utils.isAddress(this.address) || this.address.toLowerCase() === this.userAddress.toLowerCase() || this.isUserInter(this.userLowerLevel)>=0){
                this.showWarring = true
            }else{
                this.status = 'loading'
                // isRegister
                contract.methods.isRegistered(this.userAddress).call().then(res=>{
                    if(res){
                        this.status = 'registered'
                    }else{
                        contract.methods.userRegistration(this.address).send().then(resd=>{
                            this.status = 'success'
                        }).catch(err=>{
                            console.log(err)
                            this.status = ''
                        })
                    }
                }).catch(err=>{
                    console.log(err)
                    this.status = ''
                })
                this.showWarring = false
            }
        },
        userInfo(){
            const contract = new window.web3.eth.Contract( registerAbi, this.contractAddress, { from: this.userAddress })            
            contract.methods.getUsers(this.userAddress).call().then(res=>{
                var arr = [...res]
                if(res.length>0){
                    this.userLowerLevel = arr.reverse();
                    // this.userLowerLevel = ['0x7d1164564F9B34483E17E76f1a662795839f589A','0x7d1164564F9B34483E17E76f1a662795839f589A','0x7d1164564F9B34483E17E76f1a662795839f589A','0x7d1164564F9B34483E17E76f1a662795839f589A','0x2b1430838F27825B88704704655CC55D866fa520','0x7d1164564F9B34483E17E76f1a662795839f589A','0x7d1164564F9B34483E17E76f1a662795839f589A','0x7d1164564F9B34483E17E76f1a662795839f589A','0x7d1164564F9B34483E17E76f1a662795839f589A','0x7d1164564F9B34483E17E76f1a662795839f589A','0x7d1164564F9B34483E17E76f1a662795839f589A','0x2b1430838F27825B88704704655CC55D866fa520','0x7d1164564F9B34483E17E76f1a662795839f589A','0x7d1164564F9B34483E17E76f1a662795839f589A','0x7d1164564F9B34483E17E76f1a662795839f589A','0x7d1164564F9B34483E17E76f1a662795839f589A','0x7d1164564F9B34483E17E76f1a662795839f589A']
                }
            })       
            contract.methods.getInviter(this.userAddress).call().then(res=>{
                this.userInviter = res;
            })
        },
        isRegister(){
            const contract = new window.web3.eth.Contract( registerAbi, this.contractAddress, { from: this.userAddress }) 
            contract.methods.isRegistered(this.userAddress).call().then(res=>{
                if(res){
                    this.status = 'registered'
                }else{
                    this.status = ''
                }
            }).catch(err=>{
                console.log(err)
                this.status = ''
            })
        },
        isUserInter(arr){
            var that = this;
            var num = -1;
            if(arr.length>0){
                arr.map((item)=> {
                    if(item.toLowerCase() === that.address.toLowerCase()){
                        num = 1
                    }
                })
            }
            return num
        },
        leftPage(){
            if(this.currentPage == 1){
                return null
            }else{
                this.currentPage-=1
            }
        },
        nextPage(){
            if(this.currentPage == this.totalPage){
                return null
            }else{
                this.currentPage+=1
            }
        },
        back () { 
            this.$emit('back')
        },
        requestAccounts () {
            window.ethereum.request({ method: 'eth_requestAccounts' }).then(accounts => {
                this.userAddress = accounts[0];
            }).catch(error => {
                let code = -1
                let message = ''
                if (error.code === 4001) {
                code = 4001
                message = 'Permissions needed to continue.'
                } else {
                if (error.code) {
                    code = error.code
                    message = error.message
                } else {
                    message = error
                }
                }
                const err = { code, message }
                Promise.reject(err)
            })
        },
        getWindowNetwork () {
            window.ethereum.request({ method: 'eth_chainId' }).then(res => {
                this.chain = this.hex2int(res)
            }).catch(err => {
                Promise.reject(err)
            })
        },
        toHex (mixed) {
            return window.web3.utils.toHex(mixed)
        },
        hex2int (hex) {
            hex = hex.toString().slice(2)
            return parseInt(hex, 16)
        },
        changeEthereumChain (chainId) {
            this.switchEthereumChain(chainId).then(res => {
                this.getWindowNetwork()
            }).catch(error => {
                if (error.code === 4092) {
                    return this.addEthereumChain(chainId).then(res => {
                        this.getWindowNetwork()
                    }).catch(error => {
                        return Promise.reject(error)
                    })
                } else {
                    return Promise.reject(error)
                }
            })
        },
        switchEthereumChain (chainId) {
            window.ethereum.request({ method: 'wallet_switchEthereumChain', params: [{ chainId: this.toHex(chainId) }] }).then(result => {
                this.getWindowNetwork()
            }).catch(error => {
                let message = ''
                let code = 0
                if (error.code === 4001) {
                message = 'Permissions needed to continue.'
                code = 4001
                } else if (error.code === 4902) {
                message = 'Unrecognized chain.'
                code = 4902
                } else {
                if (error.code) {
                    code = error.code
                    message = error.message
                } else {
                    message = error
                }
                }
                const res = {
                code, message,
                }
                return Promise.reject(res)
            })
        },
        addEthereumChain (chainId) {
            const obj = this.networkBsc
            const params = {
                chainId: '0x' + obj.chainId.toString(16),
                chainName: obj.chainName,
                rpcUrls: [obj.rpcUrl],
                blockExplorerUrls: [obj.blockUrl],
                nativeCurrency: {
                name: obj.nativeName,
                symbol: obj.symbol,
                decimals: obj.decimals,
                },
            }
            window.ethereum.request({ method: 'wallet_addEthereumChain', params: [params] }).then(result => {
                this.getWindowNetwork()
            }).catch(error => {
                let message = ''
                let code = 0
                if (error.code === 4001) {
                message = 'Permissions needed to continue.'
                code = 4001
                } else if (error.code === -32602) {
                message = 'May not specify default MetaMask chain.'
                code = -32602
                } else {
                if (error.message) {
                    message = error.message
                    code = error.code
                } else {
                    message = error
                }
                }
                const res = {
                code, message,
                }
                return Promise.reject(res)
            })
        }
    },
  };
</script>

<style lang="scss" scoped>
    .pop-page{
        color: #000;
        .pop-box{
            position: fixed;
            top: calc(50vh - 241px);
            left: calc(50% - 315px);
            width: 630px;
            background: #FFFFFF;
            box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.14);
            border-radius: 37px;
            z-index: 1000;
            padding: 0 70px;
            padding-bottom: 77px;
            .close-img{
                position: absolute;
                top: 32px;
                right: 40px;
                width: 24px;
                height: 24px;
                opacity: .2;
                cursor: pointer;
            }
            .pop-text{
                width: 100%;
                text-align: center;
                font-family: 'K2D';
                font-style: normal;
                font-weight: 800;
                font-size: 40px;
                margin-top: 55px;
            }
            .register-text{
                font-family: 'K2D';
                font-style: normal;
                font-weight: 800;
                font-size: 20px;
                line-height: 100%;
                margin-top: 64px;
            }
            .lower-level-box{
                margin-top: 20px;
                display: flex;
                align-items: center;
                font-family: 'K2D';
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                img{
                    width: 16px;
                    height: 16px;
                    margin-right: 12px;
                }
            }
            .pagenation{
                margin-top: 30px;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                .left,.next{
                    width: 7px;
                    height: 12px;
                }
                .left{
                    margin-right: 10px;
                }
                .next{
                    margin-left: 10px;
                }
                .page{
                    font-family: 'K2D';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 16px;
                    .current-page{
                        width: 12px;
                        display: inline-block;
                        color: #E6373C;
                    }
                    .total-page{
                        width: 18px;
                        display: inline-block;
                    }
                }
                .opacity-6{
                    opacity: .6;
                    pointer-events: none;
                }
            }
            .number-subordinates-text{
                margin-top: 30px;
                padding-top: 30px;
                border-top: 1px solid rgba(0,0,0,.1);
                font-family: 'K2D';
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 21px;
            }
            .referrals-text{
                width: 100%;
                padding: 20px;
                margin-top: 15px;
                background: #F2F2F2;
                border-radius: 18px;
                font-family: 'K2D';
                font-style: normal;
                font-weight: 400;
                font-size: 20px;
                word-break:break-all;
            }
            .register-input{
                width: 100%;
                height: 60px;
                line-height: 60px;
                background: #F2F2F2;
                border-radius: 18px;
                border: none;
                padding: 0 20px;
                font-family: 'K2D';
                font-style: normal;
                font-weight: 400;
                font-size: 20px;
                line-height: 100%;
                margin-top: 16px;
            }
            .warring-text{
                font-family: 'K2D';
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 21px;
                color: #EA4344;
                position: relative;
                div{
                    width: 100%;
                    text-align: center;
                    position: absolute;
                    top: 15px;
                    left: 0;
                }
            }
            .connect-wallet-btn,.neterror-btn,.confirm-disabled-btn,.confirm-btn,.confirm-success-btn,.loading-btn{
                width: 100%;
                height: 60px;
                line-height: 60px;
                cursor: pointer;
                background: #EA4344;
                border-radius: 18px;
                font-family: 'K2D';
                font-style: italic;
                font-weight: 800;
                font-size: 20px;
                text-transform: uppercase;
                color: #FFFFFF;
                text-align: center;
                margin-top: 70px;
            }
            .neterror-btn{
                background: #000000;
                position: relative;
                img{
                    position: absolute;
                    left: 25px;
                    top: 15px;
                    width: 29px;
                    height: 29px;
                    opacity: 1;
                }
            }
            .confirm-disabled-btn{
                pointer-events: none;
                opacity: .4;
            }
            .confirm-success-btn{
                background: #43EA86;
            }
            .loading-btn{
                background: linear-gradient(269.45deg, #EA4344 8.71%, #4643EA 94.64%);
                display: flex;
                justify-content: center;
                align-items: center;
                img{
                    width: 32px;
                    height: 32px;
                    margin-right: 10px;
                    opacity: 1;
                }
            }
        }
    }
</style>